$(document).ready(function() {
    if (window.location.href.includes("/collections") || window.location.href.includes("/search")) {
        var loading = false; // Prevent multiple AJAX calls
        var currentPage = 1;
        var maxPages = parseInt($('#total-pages').text(), 10);
        var elementsToHide = [
            '[id^="shopify-section-template--"][id*="image_with_text"]', // Matches IDs starting with "shopify-section-template--" and containing "image_with_text"
            '[id^="shopify-section-template--"][id*="cf491ad4"]',       // Matches IDs starting with "shopify-section-template--" and containing "cf491ad4"
            '[id^="shopify-section-sections--"][id*="text-with-icons"]', // Matches IDs starting with "shopify-section-sections--" and containing "text-with-icons"
            '[id^="shopify-section-sections--"][id*="footer"]'           // Matches IDs starting with "shopify-section-sections--" and containing "footer"
        ];    // Using pattern-like selectors, because the element IDs change on every theme


        // Function to hide elements
        function hideElements() {
            elementsToHide.forEach(function(selector) {
                $(selector).hide();
            });
        }

        // Function to show elements (optional, if you want to re-display them later) e.g. when reaching the end of products
        function showElements() {
            elementsToHide.forEach(function(selector) {
                $(selector).show();
            });
        }

        // Triggered on SORT and FILTER actions (resetting page number to count from 1 on new filters/sorts)
        window.infiniteScrollURLTrigger = function() {
        currentPage = 1;
        maxPages = parseInt($('#total-pages').text(), 10)
        }
    

        // Infinite scroll logic
        $(window).scroll(function() {
            if (currentPage < maxPages) {
                //hiding unwanted elements whenever scrolling and they're visible
                hideElements();
            }
            if (loading) return;

            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 2000) {
            
                if (currentPage < maxPages) {
                    $('#loading-spinner').show();
                    loading = true;
                    loadProducts(window.location.href, false);
                } else {
                showElements();
                }
            }
            loadProductCardLinks();
        });

        // Function to load products via AJAX
        function loadProducts(params, clearGrid) {
            var url = new URL(params);
            var searchParam = url.searchParams;
            currentPage++
            searchParam.set('page', currentPage)
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'html',
                success: function(data) {
                    var newProducts = $(data).find('#product-grid').html();

                    if (clearGrid) {   // never used, since the first page is filtered and filled by the theme system
                        $('#product-grid').html(newProducts); // Clear and replace
                    } else {
                        $('#product-grid').append(newProducts); // Append for infinite scroll
                        applyMarginToWrapper();
                        joinProductLists();
                    }
                    loading = false;
                    $('#loading-spinner').hide();
                },
                error: function() {
                    loading = false;
                    $('#loading-spinner').hide();
                }
            });
        }
        function applyMarginToWrapper() {
            // Get the computed style of the other element
            var otherElement = $(".product-list")
        }
        function joinProductLists() {
            const lists = $('#product-grid .product-list');
            const first = lists[0];

            $(lists).each(function(i, list) {
                if (i === 0) return;

                Array.from(list.children).forEach(child => {
                    first.appendChild(child);
                });

                list.remove();
            });
        }   
    }
});